import React, { useState, useEffect } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import './MobileNav.sass';

import { ReactComponent as CloseIcon } from './close.svg';
import { ReactComponent as Logo } from './it-nonstop-logo-color.svg';
import { ReactComponent as Arrow } from './arrow.svg';
import SocialLargeLinks from '../../uikit/SocialLargeLinks';

interface Props {
	isOpen: boolean;
	onClick: () => void;
	data: {
		comingSoonAbout: boolean;
		comingSoonAgenda: boolean;
		comingSoonSpeakers: boolean;
		comingSoonPartners: boolean;
		comingSoonFAQ: boolean;
	};
}

function MobileNav({ isOpen, onClick, data }: Props) {
	const location = useLocation();
	const [dropDownOpen, setDropDownOpen] = useState(false);

	useEffect(() => {
		setDropDownOpen(false);
	}, [location.pathname]);

	return (
		<div className={`mobile-nav${isOpen ? ' mobile-nav--active' : ''}`}>
			<div className="mobile-nav__top">
				<NavLink className="mobile-nav__logo" to="/">
					<Logo />
				</NavLink>
				<button
					type="button"
					className="mobile-nav__close"
					onClick={() => onClick()}
				>
					<CloseIcon />
				</button>
			</div>
			<div className="mobile-nav__inner">
				<div className="mobile-nav__content">
					<ul className="mobile-nav__list">
						<li>
							{data?.comingSoonAbout
								? <span
								role="button"
								tabIndex={0}
								className="mobile-nav__link mobile-nav__link--multiple"
								onClick={() => setDropDownOpen(!dropDownOpen)}
								aria-label="button"
								onKeyPress={() => setDropDownOpen(!dropDownOpen)}
							>
								<span>About</span>
								<Arrow />
							</span>
								: <span className="mobile-nav__link mobile-nav__link--disabled">
								<span>About</span>
								<i className="mobile-nav__label">Soon</i>
							</span>
							}
							
							<ul
								className={`main-nav__dropdown main-nav-dropdown${
									dropDownOpen ? ' main-nav-dropdown--active' : ''
								}`}
							>
								<li>
									<NavLink
										className="main-nav-dropdown__link"
										to="/about-the-conference"
										activeClassName="main-nav-dropdown__link--active"
									>
										About the Conference
									</NavLink>
								</li>

								<li>
									<NavLink
										className="main-nav-dropdown__link"
										to="/about-the-conference/privacy-policy"
									>
										Privacy Policy
									</NavLink>
								</li>
								<li>
									<NavLink
										className="main-nav-dropdown__link"
										to="/about-the-conference/code-of-conduct"
									>
										Code of Conduct
									</NavLink>
								</li>
							</ul>
						</li>
						<li>
							{data?.comingSoonAgenda ? (
								<NavLink
									className="mobile-nav__link"
									to="/agenda"
									activeClassName="mobile-nav__link--active"
								>
									Agenda
								</NavLink>
							) : (
								<span className="mobile-nav__link mobile-nav__link--disabled">
									<span>Agenda</span>
									<i className="mobile-nav__label">Soon</i>
								</span>
							)}
						</li>
						<li>
							{data?.comingSoonSpeakers ? (
								<NavLink
									className="mobile-nav__link"
									to="/speakers"
									activeClassName="mobile-nav__link--active"
								>
									Speakers
								</NavLink>
							) : (
								<span className="mobile-nav__link mobile-nav__link--disabled">
									<span>Speakers</span>
									<i className="mobile-nav__label">Soon</i>
								</span>
							)}
						</li>
						<li>
							{data?.comingSoonPartners ? (
								<NavLink
									className="mobile-nav__link"
									to="/partners"
									activeClassName="mobile-nav__link--active"
								>
									Partners
								</NavLink>
							) : (
								<span className="mobile-nav__link mobile-nav__link--disabled">
									<span>Partners</span>
									<i className="mobile-nav__label">Soon</i>
								</span>
							)}
						</li>
						<li>
							{data?.comingSoonFAQ ? (
								<NavLink
									className="mobile-nav__link"
									to="/faq"
									activeClassName="mobile-nav__link--active"
								>
									FAQ
								</NavLink>
							) : (
								<span className="mobile-nav__link mobile-nav__link--disabled">
									<span>FAQ</span>
									<i className="mobile-nav__label">Soon</i>
								</span>
							)}
						</li>
					</ul>
				</div>
				<div className="mobile-nav__bottom">
					<h2 className="uikit-label-small-caps">Contact US</h2>
					<a
						href="mailto:it-nonstop@dataart.com"
						className="uikit-heading-tiny mobile-nav__email"
					>
						it-nonstop@dataart.com
					</a>
					<SocialLargeLinks />
				</div>
			</div>
		</div>
	);
}

export default MobileNav;
